import React from 'react';
import {Layout} from 'antd';
import './index.style.less';
import AppLogo from '../components/AppLogo';
import PropTypes from 'prop-types';
import {AiOutlineMenu} from 'react-icons/ai';
import {useAuthMethod, useAuthUser} from '../../../utility/AuthHooks';
import {useNavigate} from 'react-router-dom';
import {FiLogOut} from 'react-icons/fi';

const AppHeader = ({isCollapsed, onToggleSidebar}) => {
  const {Header} = Layout;
  const {user} = useAuthUser();
  const {logout} = useAuthMethod();
  const navigate = useNavigate();

  const salir = () => {
    logout();
    navigate('/');
  };

  return (
    <Header className='app-header'>
      <a className='trigger' onClick={() => onToggleSidebar(!isCollapsed)}>
        <AiOutlineMenu />
      </a>
      <AppLogo />
      <div className='app-header-user'>
        <span className='app-header-user-name'>
          {user?.user_nickname?.toUpperCase() || ''}
        </span>
        <a
          className='app-header-logout'
          onClick={salir}
          title='Cerrar sesión'>
          <FiLogOut />
        </a>
      </div>
    </Header>
  );
};

export default AppHeader;

AppHeader.propTypes = {
  onToggleSidebar: PropTypes.func,
  isCollapsed: PropTypes.bool,
};
